export const SUPPORTED_LOCALES = ["en", "nl", "ro"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: "English",
  nl: "Nederlands",
  ro: "Română",
};

/**
 * Resolve the best matching supported locale from a BCP 47 language tag.
 * Falls back to `"en"` if nothing matches.
 */
export function resolveLocale(requested?: string): SupportedLocale {
  if (!requested) return "en";
  const base = requested.split("-")[0]?.toLowerCase();
  if (base && SUPPORTED_LOCALES.includes(base as SupportedLocale)) {
    return base as SupportedLocale;
  }
  return "en";
}
